import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';

export const BlockSkeleton: FC<{
  children: ReactNode;
  id: string;
  className?: string;
  labelSize?: number;
}> = ({ id, className, labelSize, children }) => {
  return (
    <div id={id} className={classNames('card h-100 bg-lvl1 shadow-sm', className)}>
      <div className="card-body">
        <h5 className="card-title d-flex align-items-center">
          <Skeleton width={`${labelSize}em`} />
        </h5>
        <div className="card-text">{children}</div>
      </div>
    </div>
  );
};
